import styled from 'styled-components';

import {
    colorProps,
    fontProps,
    marginProps,
    paddingProps,
    sizeProps,
} from '@styles/styleProps';

const BaseText = styled.p`
  ${sizeProps}
  ${fontProps}
  ${colorProps}
  ${marginProps}
  ${paddingProps}
`;

export default BaseText;
